import { __assign, __rest } from "tslib";
import React from 'react';
import { Box } from '@marvelapp/ui';
export default function PanelBox(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Box, __assign({ bg: "snow", borderRadius: 3, boxShadow: "button.ghost", fontSize: 12, id: "css-content", lineHeight: 1.3, padding: 3 }, props), children));
}
